const ADVICE_ACTIVITIES_CORRECTION = 'activitiesCorrection';
export default ADVICE_ACTIVITIES_CORRECTION;
